module.exports = __webpack_public_path__ + "static/media/11.f59503c8.JPG";